export var DEFAULT_FILTER_LENGTH = 2;
export var DEFAULT_SORT_OPTIONS_LENGTH = 2;
export var sortTypes = [{
  label: 'Mais relevantes',
  value: 'MORE_RELEVANT'
}, {
  label: 'Mais recentes',
  value: 'MOST_RECENT'
}, {
  label: 'Avaliações positivas',
  value: 'MORE_POSITIVE'
}, {
  label: 'Avaliações negativas',
  value: 'MORE_NEGATIVE'
}];